/**
 * Query parameters of the template pages that start from a client's installation.
 */

/** A new template entered by hand (`…/integration-templates/new?plugin=`). */
export const TemplateNewParam = {
  /** The picked plugin, so a reload keeps the pick. */
  PLUGIN: 'plugin'
} as const;

/** A new template saved from a client's installation (`…/integration-templates/new?…`). */
export const TemplateFromConnectionParam = {
  CLIENT: 'fromClient',
  CONNECTION: 'fromConnection',
  NAME: 'name',
  /** Once per key each client supplies itself. */
  PER_CLIENT_KEY: 'perClientKeys'
} as const;

/** A client's installation copied to other clients (`…/integration-templates/copy?…`). */
export const TemplateCopyParam = {
  CLIENT: 'client',
  CONNECTION: 'connection',
  /** The installation's plugin: the board cannot read a client's installation itself. */
  PLUGIN: 'plugin',
  /** The installation's name, for the header. */
  INSTALLATION: 'installation',
  /** Present when the installation is on the client's own Bridge: its own credentials travel. */
  OWN_BRIDGE: 'ownBridge'
} as const;
